export default {"id":"743978ad","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}